import { navigate } from '@reach/router'
import { change } from 'redux-form'

import { FORM_NAME } from '@cinch/oxd-containers/listing-filters/src/listing-filters.container'
import { FORM_NAME as DEALER_FORM_NAME } from '@cinch/oxd-containers/dealer-listing-filters/src/listing-filters.container'
import { actions as vehicleActions, types } from '@cinch/oxd-redux/vehicles/src'
import { actions as dealerVehicleActions, types as dealerTypes } from '@cinch/oxd-redux/dealer-vehicles/src'
import { queryString } from '@cinch/oxd-utils/requests/src'
import { FEATURES, hasFeatureFlag } from '@cinch/oxd-utils/feature-flags/src'

export default (store: any) => (next: any) => (action: any) => {
  const { type, payload } = action

  if (type === types.VEHICLE_SEARCH_SUCCESS || type === types.VEHICLE_FORM_UPDATE) {
    Object.keys(payload).forEach((k) => {
      const ignoreKeys = ['latitude', 'longitude', 'pageSize', 'sortingCriteria', 'dealershipStatus']

      if (!ignoreKeys.includes(k)) {
        store.dispatch(change(FORM_NAME, k, payload[k]))
      }
    })
  }

  if (type === types.VEHICLE_FORM_UPDATE) {
    store.dispatch(vehicleActions.getListings(payload))
  }

  if (type === types.VEHICLE_LISTING_SUCCESS) {
    // update url with form data
    const { params } = action.meta
    const queryParams = { ...params }
    delete queryParams.dealershipStatus
    delete queryParams.projectName
    delete queryParams.postcode
    delete queryParams.town

    navigate(`/find-vehicle?${queryString(queryParams)}`, { replace: action.meta!.replace })
  }

  if (type === dealerTypes.DEALER_VEHICLE_SEARCH_SUCCESS || type === dealerTypes.DEALER_VEHICLE_FORM_UPDATE) {
    Object.keys(payload).forEach((k) => {
      const ignoreKeys = ['latitude', 'longitude', 'pageSize', 'sortingCriteria', 'dealershipStatus']

      if (!ignoreKeys.includes(k)) {
        store.dispatch(change(DEALER_FORM_NAME, k, payload[k]))
      }
    })
  }

  if (type === dealerTypes.DEALER_VEHICLE_FORM_UPDATE) {
    store.dispatch(dealerVehicleActions.getListings(payload))
  }

  if (type === dealerTypes.DEALER_VEHICLE_LISTING_SUCCESS) {
    // update url with form data
    const { params } = action.meta
    const queryParams = { ...params }
    delete queryParams.dealershipStatus
    delete queryParams.projectName
    delete queryParams.postcode
    delete queryParams.town

    const prefix = hasFeatureFlag(FEATURES.CAMBRIDGE) ? '/dealers' : ''

    navigate(`${prefix}/find-vehicle?${queryString(queryParams)}`, { replace: action.meta!.replace })
  }

  return next(action)
}
